export default __webpack_public_path__ + "static/media/card-img-2.5cc52452.png";